import React from 'react';
import { useHistory } from 'react-router-dom';
import ReactHtmlParser from 'react-html-parser';

import './Banner.scss';

export default function Banner({ data }: Record<string, any>) {
  const history = useHistory();

  const buttonClick = (callToAction) => (e) => {
    e.preventDefault();

    if (callToAction.slug) {
      history.push(`/static/${ callToAction.slug }`);
      return;
    }

    if (callToAction.type === 'page') {
      history.push(callToAction.value);
      return;
    }
  };

  return (
    <div className="banner">
      { data.title && <div className="banner__title">{ data.title }</div> }
      { data.body && <div className="banner__desc">{ ReactHtmlParser(data.body) }</div> }
      {
        data.callToAction?.buttonLabel && (
          <button className="btn btn--primary btn--medium banner__button" onClick={ buttonClick(data.callToAction) }>
            { data.callToAction.buttonLabel }
          </button>
        )
      }
      { data.footerInfo && <div className="banner__info">{ data.footerInfo }</div> }
      { data.image && <img className="banner__img" src={ data.image?.url } alt={ data.image?.alternativeText } /> }
    </div>
  );
}
